import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingSocialIcons from "./FloatingSocialIcons";
import { useEffect, useMemo } from "react";

export default function Layout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  const showFloatingIcons = useMemo(
    () => !location.pathname.startsWith("/admin") && !location.pathname.startsWith("/student") && !location.pathname.startsWith("/auth") && !location.pathname.startsWith("/booking"),
    [location.pathname]
  );

  return (
    <div className="min-h-screen bg-white font-body">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:bg-primary focus:text-white focus:px-4 focus:py-2 focus:rounded-md focus:font-semibold focus:outline focus:outline-4 focus:outline-white focus:outline-offset-2"
      >
        Skip to main content
      </a>
      <Navbar />
      <main id="main-content">
        <Outlet />
      </main>
      <Footer />
      {showFloatingIcons && <FloatingSocialIcons />}
    </div>
  );
}